import { ReadonlySignal, createSignal } from '../../lib/signal';

type Volume = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export interface AudioOptions {
    loop?: boolean;
}

export interface AudioController {
    start: VoidFunction;
    stop: VoidFunction;
    destroy: VoidFunction;
}

export interface AudioFactory {
    (options?: AudioOptions): AudioController;
}

export interface AudioManager {
    muteSignal: ReadonlySignal<boolean>;
    createMuteSource(): {
        mute: VoidFunction;
        unmute: VoidFunction;
    }

    volumeSignal: ReadonlySignal<Volume>;
    setVolume(volume: Volume): void;
}

export const createAudioManager = (): AudioManager => {
    let activeMutedSources = 0;
    const muteSignal = createSignal(false);
    const volumeSignal = createSignal<Volume>(10);

    // sound -> volume -> mute -> destination.

    return {
        muteSignal,
        volumeSignal,

        setVolume(value: Volume) {
            volumeSignal.emit(value);
        },

        createMuteSource() {
            let muted = false;
            return {
                mute() {
                    if (!muted) {
                        muted = true;
                        ++activeMutedSources;
                        if (activeMutedSources === 1) {
                            muteSignal.emit(true);
                        }
                    }
                },
                unmute() {
                    if (muted) {
                        muted = false;
                        --activeMutedSources;
                        if (activeMutedSources === 0) {
                            muteSignal.emit(false);
                        }
                    }
                },
            };
        },

    };
};
